module.exports = __webpack_public_path__ + "img/01my_product.8cbb8c47.png";